<template>
  <div>
    <Header :logoUrl="logoUrl" :desarrollo="desarrollo"/>
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Header from "../core/Header";
import Footer from "./Footer.vue";
export default {
  name: "TorresPanorama",
  data() {
    return {
      desarrollo: 'torrespanorama',
      logoUrl: "https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrespanorama/terrenoLogo/torrespanorama_logo.svg",
    };
  },
  components: {
    Header,
    Footer,
  },
};
</script>
<style>
:root {
  --animate-duration: 250ms;
  --animate-delay: 0.9s;
}
.quick {
  transition-duration: "0ms" !important;
}
</style>
